import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { clearLocalStorage } from "utils/auth/localStorage";
import TokenService from "utils/auth/Token.service";
import { setCookiesCurrentPage, isUnknown } from "utils/functions";

const tokenService = new TokenService();

const Home = () => {
  const router = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      const tokenIdentity = tokenService.getToken();

      if (tokenIdentity) {
        if (isUnknown(tokenService.decodeToken().role)) {
          setCookiesCurrentPage("unauthorized");
          router("/unauthorized");
        } else {
          setCookiesCurrentPage("lobby");
          router("/private/lobby");
        }
        return;
      }

      const currentPath = window.location.pathname;
      if (currentPath !== "/multiple-realms" && !tokenIdentity) {
        clearLocalStorage();
        tokenService.deleteToken();
        router("/multiple-realms");
      }
    };
    fetchData();
  }, []);

  return <></>;
};

export default Home;
